/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AzureAppUptimeResponse
 */
export interface AzureAppUptimeResponse {
    /**
     * 
     * @type {number}
     * @memberof AzureAppUptimeResponse
     */
    monthly_rolling_average_uptime_percent: number;
}

/**
 * Check if a given object implements the AzureAppUptimeResponse interface.
 */
export function instanceOfAzureAppUptimeResponse(value: object): value is AzureAppUptimeResponse {
    if (!('monthly_rolling_average_uptime_percent' in value) || value['monthly_rolling_average_uptime_percent'] === undefined) return false;
    return true;
}

export function AzureAppUptimeResponseFromJSON(json: any): AzureAppUptimeResponse {
    return AzureAppUptimeResponseFromJSONTyped(json, false);
}

export function AzureAppUptimeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AzureAppUptimeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'monthly_rolling_average_uptime_percent': json['monthlyRollingAverageUptimePercent'],
    };
}

export function AzureAppUptimeResponseToJSON(json: any): AzureAppUptimeResponse {
    return AzureAppUptimeResponseToJSONTyped(json, false);
}

export function AzureAppUptimeResponseToJSONTyped(value?: AzureAppUptimeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monthlyRollingAverageUptimePercent': value['monthly_rolling_average_uptime_percent'],
    };
}

